export default {
      id: "i-profile-user-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-profile-user",
      toString: function () {
        return this.url;
      }
    }